import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class EmptyStateText extends BaseOption {
  static userInterfaceComponent = {
    label: "Empty State Text",
    component: inspectorTools.SIMPLE_INPUT,
    useVerticalOrientation: true,
    descriptionMessage: "Text to be shown when feed is empty",
  };

  static defaultValue = "There are no items to display...";
}
